/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/useQaWorkspaceCover.ts
 * FILE_ID: JOBHUB-QA-WORKSPACE-COVER-HOOK-001
 * PURPOSE: ITP cover for Save to library (ITP modal and phone) and the starting cover passed to Export, with this QA's cover image and size.
 * Reused from: packages/job-hub/src/jobs/qa/useItpCover.ts (useItpCover); packages/job-hub/src/jobs/tabs/job-qa/useInspectionRecordSettings.ts (useInspectionRecordSettings)
 */
import { useItpCover } from '../../qa/useItpCover'
import type { ItpCoverFields } from '../../qa/itpCover'
import { useInspectionRecordSettings } from './useInspectionRecordSettings'

export function useQaWorkspaceCover(
  jobId: number,
  orgId: number | undefined,
  inspectionId: string | null | undefined,
  classification: string,
): ItpCoverFields {
  const records = useInspectionRecordSettings(inspectionId ?? '', jobId, orgId)
  return useItpCover(jobId, {
    classification,
    ...(records.loaded
      ? {
        coverImageUrl: records.coverImageUrl,
        coverImageWidthMm: records.settings.cover_image_width_mm ?? null,
        coverImageHeightMm: records.settings.cover_image_height_mm ?? null,
        include: records.include,
      }
      : {}),
  })
}
